import { render } from "./birthday-list.vue?vue&type=template&id=1ce0afb9&scoped=true"
import script from "./birthday-list.vue?vue&type=script&lang=js"
export * from "./birthday-list.vue?vue&type=script&lang=js"

import "./birthday-list.vue?vue&type=style&index=0&id=1ce0afb9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce0afb9"]])

export default __exports__